import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CategoryCard from './CategoryCard';
import {reqPost,reqGet} from '../../../service';

const CategoryBox = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 12px 0 20px;
  scroll-margin-top: 160px;

  /* 모바일: 현재(마지막) 단계만 노출 — 이전 단계는 RightSummary 에서 확인 */
  @media screen and (max-width: 1024px) {
    display: ${p => p.$isCurrent ? 'flex' : 'none'};
  }
`;

const CategoryHeader = styled.div`
  display: flex;
  color: ${p => p.theme.text};
  font-size: 16px;
  font-weight: 700;
  justify-content: flex-start;
  margin: 8px 0 12px;
  gap: 10px;
  align-items: center;
`;

const CategoryInfo = styled.div`
  font-size: 11px;
  color: ${p => p.theme.accent};
  background: ${p => p.theme.accentLight};
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
`;

const TypeBadge = styled.div`
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid ${p => p.theme.accent};
  color: ${p => p.theme.accent};
  background: ${p => p.theme.bgCard};
`;

const ItemsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
`;

export default function ItemCard(props){
   const [CategoryList,setCategoryList] =useState([]);
   const [change, setChange]=useState(false);

   useEffect(()=>{
    setChange(!change);
    getCategoryList();
  },[props.categoryCheck]);

    useEffect(()=>{
        getCategoryList();
    },[props.SubCategory]);

    const getCategoryList = ()=>{
        reqGet('/api/CategoryList',{group_id:props.Key},(res)=>{
            setCategoryList(res);
        });
    }

    const [SelectedData,setSelectedData]=useState(false);

    const visibleCats = CategoryList.filter(i => props.categoryCheck.includes(i.main_category));

    return(<>
        {visibleCats.map((item, idx, arr) => (
        <CategoryBox
            key={idx}
            id={`cat-${item.group_id}-${item.main_category}`}
            $isCurrent={idx === arr.length - 1}
        >
        <CategoryHeader>
        {item.main_category}
        <TypeBadge>단일 선택</TypeBadge>
        <CategoryInfo>{item.info}</CategoryInfo>
        </CategoryHeader>
        <div style={{display:'flex'}}>
        <ItemsContainer>
            <CategoryCard
            group_id={item.group_id}
            Key={item.main_category}
            SelectedData = {SelectedData}
            ItemStack={props.ItemStack}
            idx={idx}
            calcValue={(e)=> {
                    setSelectedData(e.NAME);
                    props.calcValue(
                        {
                            GROUP:e.GROUP,
                            Key:e.Key,
                            NAME:e.NAME,
                            PRICE:Number(e.PRICE),
                            DESCRIPTION:e.DESCRIPTION,
                            NEXT:e.NEXT
                        }
                        );
                }}
            setTotalList={props.setTotalList}
            change={change}
            CategoryList={CategoryList}
                >
            </CategoryCard>
         </ItemsContainer>
         </div>
         </CategoryBox>))}
        </>
       );
}
